import { Button as MuiButton } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { getMode } from "../../redux/layoutSlice";

export default function Button({ children, variant, sx, ...props }: any) {
  const mode = useSelector(getMode);
  return (
    <MuiButton
      variant={variant}
      sx={{
        fontSize: 14,
        borderRadius: "8px",
        boxShadow: "none",
        minWidth: 80,
        textTransform: "capitalize",
        backgroundColor: variant === "contained" ? "#2B7FFF" : "transparent",
        border:
          variant === "contained"
            ? "none"
            : variant === "outlined"
            ? `1px solid ${mode === "dark" ? "#1E2939" : "#E5E7EB"}`
            : "",
        color: variant === "contained" ? "#fff" : mode === "dark" ? "#fff" : "#030712",
        whiteSpace: "nowrap",
        "&:hover": {
          // border:
          //   variant === "contained"
          //     ? "1px solid ${darkenHexColor(btnColor, 50)}"
          //     : btnColor
          //       ? `1px solid ${darkenHexColor(btnColor, 50)}`
          //       : "",
          // backgroundColor: variant === "contained" ? btnColor : "transparent",
          border:
            variant === "outlined" ? `1px solid ${mode === "dark" ? "#1E2939" : "#E5E7EB"}` : "",
          backgroundColor: variant === "outlined" ? "transparent" : "",
          boxShadow: "none",
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </MuiButton>
  );
}
